module.exports = __webpack_public_path__ + "static/media/vip_title_2.1008f364.png";